import { createResource, type RouteResource } from 'react-resource-router';

import type { LogsResponseType } from '../../../common/utils/types';
import { fetchLogs } from '../endpoints';

export const logsResource: RouteResource<LogsResponseType> = createResource<LogsResponseType>({
	type: 'ui-get-logs',
	getKey: (routerContext) => {
		const integrationId = routerContext.match.params.integrationId;
		const urlParam = new URLSearchParams();

		Object.entries(routerContext.query).forEach(([key, value]) => {
			if (value) {
				urlParam.set(key, value);
			}
		});

		return !!integrationId
			? `integration-${integrationId}-logs#${urlParam.toString()}`
			: `ui-get-logs#${urlParam.toString()}`;
	},
	getData: async (routerContext) => {
		return fetchLogs({
			fromUnit: routerContext.query?.fromUnit,
			fromValue: routerContext.query?.fromValue,
			startTimestamp: routerContext.query?.startTimestamp,
			endTimestamp: routerContext.query?.endTimestamp,
			eventCategories: routerContext.query?.eventCategories,
			levels: routerContext.query?.levels,
			size: routerContext.query?.size ?? 30,
			insertedAt: routerContext.query?.insertedAt,
			searchString: routerContext.query?.searchString,
			pageDirection: routerContext.query?.pageDirection ?? 'NEXT',
			integrationId: routerContext.match.params.integrationId,
		});
	},
	maxAge: 60 * 1000, // 1 minutes,
	isBrowserOnly: true,
});
